// @modified : method spoof default of requestDelete
// @version V0.0.5 [Monday - 2022228_1863] : add forgotten RESET_ERROR_RESPONSE, REQUEST_SENDING on requestCreate, update, delete
// @version V0.0.4 [Sunday - 2022116_22523] : set error response to requestStatus state
// @version V0.0.3 : add requestStatus, notifyCaptionBegin/Error, commit after success only when have commitName, callback
// @version V0.0.2 [Monday - 20201130_215344] : mutation as optional
// @version V0.0.1 [Saturday - 20201114_204124] : init
import {
    ADD_IN_LIST, REMOVE_IN_LIST, UPDATE_IN_LIST
} from "../../constant-types";
import {
    clearNotify,
    notify,
    notifyConfirmation
} from "../notification";
import {
    sendRequest
} from "../request";

export function requestCreate(url, form, commit, commitName = ADD_IN_LIST, notifyCaptionBegin = 'menyimpan...', notifyCaptionError = 'gagal menyimpan', successCallback = () => {}, errorCallback = () => {}, finishCallback = () => {}) {
    notify('info', notifyCaptionBegin, null)
    commit('requestStatus/RESET_ERROR_RESPONSE', null, { root : true})
    commit('requestStatus/REQUEST_SENDING', null, { root : true})
    return sendRequest(url, form, 'post', (newItem) => {
        clearNotify()
        if (commitName !== '') commit(commitName, newItem)
        commit('requestStatus/REQUEST_SUCCESS', null, { root : true})
        successCallback(newItem)
        return true
    }, (error) => {
        clearNotify()
        notify('error', notifyCaptionError)
        commit('requestStatus/REQUEST_FAILED', null, { root : true})
        commit('requestStatus/SET_ERROR_RESPONSE', error, { root : true})
        errorCallback(error)
        return false
    }, (resultBoolean) => {
        commit('requestStatus/REQUEST_SENDED', null, { root : true})
        finishCallback(resultBoolean)
        return resultBoolean
    }
    )
}

export function requestUpdate(url, form, commit, commitName = UPDATE_IN_LIST, notifyCaptionBegin = 'mengupdate...', notifyCaptionError = 'gagal mengupdate', successCallback = () => {}, errorCallback = () => {}, finishCallback = () => {}) {
    notify('info', notifyCaptionBegin, null)
    commit('requestStatus/RESET_ERROR_RESPONSE', null, { root : true})
    commit('requestStatus/REQUEST_SENDING', null, { root : true})
    return sendRequest(url, form, 'put', (updatedItem) => {
        clearNotify()
        if (commitName !== '') commit(commitName, updatedItem)
        commit('requestStatus/REQUEST_SUCCESS', null, { root : true})
        successCallback(updatedItem)
        return true
    }, (error) => {
        clearNotify()
        notify('error', notifyCaptionError)
        commit('requestStatus/REQUEST_FAILED', null, { root : true})
        commit('requestStatus/SET_ERROR_RESPONSE', error, { root : true})
        errorCallback(error)
        return false
    }, (resultBoolean) => {
        commit('requestStatus/REQUEST_SENDED', null, { root : true})
        return resultBoolean
    }
    )
}

export function requestDelete(url, form, commit, confirmationLabel, commitName = REMOVE_IN_LIST, notifyCaptionBegin = 'menghapus...', notifyCaptionError = 'gagal menghapus', successCallback = () => {}, errorCallback = () => {}, finishCallback = () => {}) {
    // confirmation send delete
    notifyConfirmation('apakah yakin ingin menghapus ' + confirmationLabel,
    // continue
    () => {
        notify('info', notifyCaptionBegin,null)
        commit('requestStatus/RESET_ERROR_RESPONSE', null, { root : true})
        commit('requestStatus/REQUEST_SENDING', null, { root : true})
        // sendRequest('user', user, 'delete', 
        sendRequest(url, form, 'delete', 
            (deletedItem) => {
                // delete related user in list
                if (commitName !== '') commit(commitName, deletedItem)
                clearNotify()
                commit('requestStatus/REQUEST_SUCCESS', null, { root : true})
                successCallback(deletedItem)
                return true
            }, 
            (error) => {
                clearNotify()
                notify('error', notifyCaptionError)
                commit('requestStatus/SET_ERROR_RESPONSE', error, { root : true})
                errorCallback(error)
                return false
            }, 
            (resultBoolean) => {
                commit('requestStatus/REQUEST_SENDED', null, { root : true})
                return resultBoolean
            }, false, true, false)
    },
    // stop
    () => {}
)
}
